import React, { Component } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { ConsumidorFinalForm } from "./components/ConsumidorFinalForm";
import "./styles/CreacionConsumidorFinal.css";

class CreacionConsumidorFinal extends Component {
    state = {
        idConsumidorFinal: null,
    };

    componentDidMount() {
        const { match } = this.props;
        const idConsumidorFinal = match.params.id;
        this.setState({ idConsumidorFinal });
    }

    regresar = () => {
        this.props.history.goBack();
    };

    render() {
        let titulo = "Crear consumidor final";
        if (this.state.idConsumidorFinal) {
            titulo = "Editar consumidor final";
        }

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <CardForm
                    icon="configuraciones_activo"
                    titulo={titulo}
                    subtitulo=""
                    col="12"
                >
                    <ConsumidorFinalForm
                        idConsumidorFinal={this.state.idConsumidorFinal}
                        regresar={this.regresar}
                    />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const user = state.login.me;

    return {
        user,
    };
};

export default connect(mstp, {})(CreacionConsumidorFinal);
